import { render, staticRenderFns } from "./editorScore.vue?vue&type=template&id=30ceb620&scoped=true"
import script from "./editorScore.vue?vue&type=script&lang=js"
export * from "./editorScore.vue?vue&type=script&lang=js"
import style0 from "./editorScore.vue?vue&type=style&index=0&id=30ceb620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ceb620",
  null
  
)

export default component.exports